module.exports = __webpack_public_path__ + "static/img/2.34ee517.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/2.png
// module id = MzTH
// module chunks = 0